import { createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "../Action/apiRequest";



const apiSlice = createSlice({
  name: "api",
  initialState: {
 
    login: { data: null, loading: false, error: null },
    logout: { data: null, loading: false, error: null },
    profile: { data: null, loading: false, error: null },
    branches: { data: null, loading: false, error: null },
    branchDetails: { data: null, loading: false, error: null },
    branchCreate: { data: null, loading: false, error: null },
    branchUpdate: { data: null, loading: false, error: null },
    centersList: { data: null, loading: false, error: null },
    governoratesList: { data: null, loading: false, error: null },
    countriesList: { data: null, loading: false, error: null },
    educations: { data: null, loading: false, error: null },
    educationDetails: { data: null, loading: false, error: null },
    educationCreate: { data: null, loading: false, error: null },
    educationUpdate: { data: null, loading: false, error: null },
    departments: { data: null, loading: false, error: null },
    departmentDetails: { data: null, loading: false, error: null },
    departmentCreate: { data: null, loading: false, error: null },
    departmentUpdate: { data: null, loading: false, error: null },
    departmentDelete: { data: null, loading: false, error: null },
    departmentBranches: { data: null, loading: false, error: null },
    positions: { data: null, loading: false, error: null },
    positionDetails: { data: null, loading: false, error: null },
    positionCreate: { data: null, loading: false, error: null },
    positionUpdate: { data: null, loading: false, error: null },
    positionDelete: { data: null, loading: false, error: null },
    employees: { data: null, loading: false, error: null },
    employeeDetails: { data: null, loading: false, error: null },
    employeeCreate: { data: null, loading: false, error: null },
    employeeChangeStatus: { data: null, loading: false, error: null },
    employeeUpdate: { data: null, loading: false, error: null },
    employeeDelete: { data: null, loading: false, error: null },
    shifts: { data: null, loading: false, error: null },
    shiftDetails: { data: null, loading: false, error: null },
    shiftCreate: { data: null, loading: false, error: null },
    shiftUpdate: { data: null, loading: false, error: null },
    shiftDelete: { data: null, loading: false, error: null },
    leaveTypes: { data: null, loading: false, error: null },
    leaveTypeDetails: { data: null, loading: false, error: null },
    leaveTypeCreate: { data: null, loading: false, error: null },
    leaveTypeUpdate: { data: null, loading: false, error: null },
    leaveTypeDelete: { data: null, loading: false, error: null },
    biometricDevices: { data: null, loading: false, error: null },
    biometricDeviceDetails: { data: null, loading: false, error: null },
    biometricDeviceCreate: { data: null, loading: false, error: null },
    biometricDeviceUpdate: { data: null, loading: false, error: null },
    biometricDeviceDelete: { data: null, loading: false, error: null },
    penalties: { data: null, loading: false, error: null },
    penaltyDetails: { data: null, loading: false, error: null },
    penaltyCreate: { data: null, loading: false, error: null },
    penaltyUpdate: { data: null, loading: false, error: null },
    penaltyDelete: { data: null, loading: false, error: null },
    leaveRequests: { data: null, loading: false, error: null },
    leaveRequestDetails: { data: null, loading: false, error: null },
    leaveRequestCreate: { data: null, loading: false, error: null },
    leaveRequestUpdate: { data: null, loading: false, error: null },
    leaveRequestDelete: { data: null, loading: false, error: null },
    leaveRequestStatusUpdate: { data: null, loading: false, error: null },
    kpiCategories: { data: null, loading: false, error: null },
    kpiCategoryDetails: { data: null, loading: false, error: null },
    kpiCategoryCreate: { data: null, loading: false, error: null },
    kpiCategoryUpdate: { data: null, loading: false, error: null },
    kpiCategoryDelete: { data: null, loading: false, error: null },
    rewards: { data: null, loading: false, error: null },
    rewardDetails: { data: null, loading: false, error: null },
    rewardCreate: { data: null, loading: false, error: null },
    rewardUpdate: { data: null, loading: false, error: null },
    rewardDelete: { data: null, loading: false, error: null },
    salaryComponentDetails: { data: null, loading: false, error: null },
    salaryComponentUpdate: { data: null, loading: false, error: null },
    salaryComponentDelete: { data: null, loading: false, error: null },
    salaryComponents: { data: null, loading: false, error: null },
    salaryComponentCreate: { data: null, loading: false, error: null },
    accountsTree: { data: null, loading: false, error: null },
    addAccount: { data: null, loading: false, error: null },
    kpis: { data: null, loading: false, error: null },
    kpiDetails: { data: null, loading: false, error: null },
    kpiCreate: { data: null, loading: false, error: null },
    kpiUpdate: { data: null, loading: false, error: null },
    kpiDelete: { data: null, loading: false, error: null },
    kpiCycles: { data: null, loading: false, error: null },
    kpiCycleDetails: { data: null, loading: false, error: null },
    kpiCycleCreate: { data: null, loading: false, error: null },
    kpiCycleUpdate: { data: null, loading: false, error: null },
    kpiCycleDelete: { data: null, loading: false, error: null },
    employeeKpisAssignment: { data: null, loading: false, error: null },
    employeeKpisAssignmentDetails: { data: null, loading: false, error: null },
    employeeKpisAssignmentCreate: { data: null, loading: false, error: null },
    employeeKpisAssignmentUpdate: { data: null, loading: false, error: null },
    employeeKpisAssignmentDelete: { data: null, loading: false, error: null },
    employeeKpisScores: { data: null, loading: false, error: null },
    employeeKpisScoreDetails: { data: null, loading: false, error: null },
    employeeKpisScoreCreate: { data: null, loading: false, error: null },
    employeeKpisScoreUpdate: { data: null, loading: false, error: null },
    employeeKpisScoreDelete: { data: null, loading: false, error: null },
    treasuries: { data: null, loading: false, error: null },
    treasuryDetails: { data: null, loading: false, error: null },
    treasuryCreate: { data: null, loading: false, error: null },
    treasuryUpdate: { data: null, loading: false, error: null },
    treasuryDelete: { data: null, loading: false, error: null },
    treasuryBalance: { data: null, loading: false, error: null },
    treasuriesForPay: { data: null, loading: false, error: null },
    availableAccounts: { data: null, loading: false, error: null },
    postingAccounts: { data: null, loading: false, error: null },
    expenses: { data: null, loading: false, error: null },
    expenseDetails: { data: null, loading: false, error: null },
    expenseCreate: { data: null, loading: false, error: null },
    expenseUpdate: { data: null, loading: false, error: null },
    expenseDelete: { data: null, loading: false, error: null },
    expensePay: { data: null, loading: false, error: null },
    expenseCancel: { data: null, loading: false, error: null },
    fixedAssets: { data: null, loading: false, error: null },
    fixedAssetDetails: { data: null, loading: false, error: null },
    fixedAssetCreate: { data: null, loading: false, error: null },
    fixedAssetUpdate: { data: null, loading: false, error: null },
    fixedAssetDelete: { data: null, loading: false, error: null },
    fixedAssetDispose: { data: null, loading: false, error: null },
    costCenters: { data: null, loading: false, error: null },
    costCenterDetails: { data: null, loading: false, error: null },
    costCenterCreate: { data: null, loading: false, error: null },
    costCenterUpdate: { data: null, loading: false, error: null },
    costCenterDelete: { data: null, loading: false, error: null },
    paymentMethods: { data: null, loading: false, error: null },
    paymentMethodDetails: { data: null, loading: false, error: null },
    paymentMethodCreate: { data: null, loading: false, error: null },
    paymentMethodUpdate: { data: null, loading: false, error: null },
    paymentMethodDelete: { data: null, loading: false, error: null },
    journalEntries: { data: null, loading: false, error: null },
    journalEntryDetails: { data: null, loading: false, error: null },
    journalEntryCreate: { data: null, loading: false, error: null },
    journalEntryUpdate: { data: null, loading: false, error: null },
    journalEntryDelete: { data: null, loading: false, error: null },
    journalEntryPost: { data: null, loading: false, error: null },
    journalEntryVoid: { data: null, loading: false, error: null },
    journalEntryPendingCount: { data: null, loading: false, error: null },
    journalEntryAccountStatement: { data: null, loading: false, error: null },
    vouchers: { data: null, loading: false, error: null },
    voucherDetails: { data: null, loading: false, error: null },
    voucherDelete: { data: null, loading: false, error: null },
    voucherApprove: { data: null, loading: false, error: null },
    voucherCancel: { data: null, loading: false, error: null },
    paymentVoucherCreate: { data: null, loading: false, error: null },
    receiptVoucherCreate: { data: null, loading: false, error: null },
    voucherUpdate: { data: null, loading: false, error: null },
    cashierCustodies: { data: null, loading: false, error: null },
    cashierCustodyDetails: { data: null, loading: false, error: null },
    cashierCustodyCreate: { data: null, loading: false, error: null },
    cashierCustodyUpdate: { data: null, loading: false, error: null },
    cashierCustodyClose: { data: null, loading: false, error: null },
    cashierCustodyDelete: { data: null, loading: false, error: null },
    cashierSessions: { data: null, loading: false, error: null },
    cashierSessionDetails: { data: null, loading: false, error: null },
    cashierSessionOpen: { data: null, loading: false, error: null },
    cashierSessionClose: { data: null, loading: false, error: null },
    cashierSessionDelete: { data: null, loading: false, error: null },
    partners: { data: null, loading: false, error: null },
    partnerDetails: { data: null, loading: false, error: null },
    partnerCreate: { data: null, loading: false, error: null },
    partnerUpdate: { data: null, loading: false, error: null },
    partnerDelete: { data: null, loading: false, error: null },
    partnersTotalShare: { data: null, loading: false, error: null },
    treasuryTransfers: { data: null, loading: false, error: null },
    treasuryTransferDetails: { data: null, loading: false, error: null },
    treasuryTransferCreate: { data: null, loading: false, error: null },
    treasuryTransferApprove: { data: null, loading: false, error: null },
    treasuryTransferCancel: { data: null, loading: false, error: null },
    profitDistributions: { data: null, loading: false, error: null },
    profitDistributionDetails: { data: null, loading: false, error: null },
    profitDistributionCalculate: { data: null, loading: false, error: null },
    profitDistributionApprove: { data: null, loading: false, error: null },
    profitDistributionPay: { data: null, loading: false, error: null },
    postDatedChecks: { data: null, loading: false, error: null },
    postDatedChecksDue: { data: null, loading: false, error: null },
    postDatedChecksSummary: { data: null, loading: false, error: null },
    postDatedChecksPartner: { data: null, loading: false, error: null },
    postDatedCheckDetails: { data: null, loading: false, error: null },
    postDatedCheckCreate: { data: null, loading: false, error: null },
    postDatedCheckUpdate: { data: null, loading: false, error: null },
    postDatedCheckCash: { data: null, loading: false, error: null },
    postDatedCheckReturn: { data: null, loading: false, error: null },
    postDatedCheckCancel: { data: null, loading: false, error: null },
    postDatedCheckDelete: { data: null, loading: false, error: null },
    exchangeRates: { data: null, loading: false, error: null },
    exchangeRateCreate: { data: null, loading: false, error: null },
    exchangeRateUpdate: { data: null, loading: false, error: null },
    exchangeRateDelete: { data: null, loading: false, error: null },
    exchangeRateConvert: { data: null, loading: false, error: null },
    exchangeRateCurrencies: { data: null, loading: false, error: null },
    financialDashboard: { data: null, loading: false, error: null },
    managementDashboard: { data: null, loading: false, error: null },
    // ===== POS — Terminals =====
    posTerminals: { data: null, loading: false, error: null },
    posTerminalDetails: { data: null, loading: false, error: null },
    posTerminalCreate: { data: null, loading: false, error: null },
    posTerminalUpdate: { data: null, loading: false, error: null },
    // ===== POS — Sessions =====
    posSessionActive: { data: null, loading: false, error: null },
    posSessionOpen: { data: null, loading: false, error: null },
    posSessionClose: { data: null, loading: false, error: null },
  },
  reducers: {
    clearApiError: (state, action) => {
      const entity = action.payload;
      if (state[entity]) {
        state[entity].error = null;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(apiRequest.pending, (state, action) => {
        const { entity } = action.meta.arg || {};
        if (!entity || !state[entity]) return;
        state[entity].loading = true;
        state[entity].error = null;
      })
      .addCase(apiRequest.fulfilled, (state, action) => {
        const entity =
          action.payload?.entity || action.meta?.arg?.entity;
        if (!entity || !state[entity]) return;
        const data = action.payload?.data;
        state[entity].loading = false;
        state[entity].data = data;
      })
      .addCase(apiRequest.rejected, (state, action) => {
        const entity =
          action.payload?.entity || action.meta?.arg?.entity;
        if (!entity || !state[entity]) return;
        state[entity].loading = false;
        state[entity].error =
          action.payload?.error ||
          action.error?.message ||
          action.payload ||
          "Unknown error";
      });
  },
});

export let apiReducer = apiSlice.reducer;
export const { clearApiError } = apiSlice.actions;
